export default __webpack_public_path__ + "static/media/DGFT-1.e446c8a2.jpg";